export enum InspectionStatus {
  NOT_COMPLIANT = 'NOT_COMPLIANT',

  COMPLIANT = 'COMPLIANT',

  MAINTENANCE = 'MAINTENANCE',
}
